import PropTypes from 'prop-types';
import React from 'react';

const FranceSpecificFooter = ({ sourcePOS, tranId }) => {
  // Fetching specific characters from the sting using index
  const digits = [2, 6, 12, 18];
  const findDigitalSignature = (string) => digits.map((s) => string[s]);
  return (
    <>
      <section>
        <article className="justify-between">
          <p className="align-left">{sourcePOS.ProductVersion ? `${sourcePOS.ProductVersion}NF ` : ''}
            {sourcePOS.SoftwareCertificateNumber ? `B${sourcePOS.SoftwareCertificateNumber} ` : ''}
            {sourcePOS.DigitalSignature ? findDigitalSignature(sourcePOS.DigitalSignature) : ''}
          </p>
        </article>
        <article className="justify-between">
          {tranId && <p>Tran ID: {tranId}</p>}
        </article>
      </section>
      <br />
      <br />
    </>
  );
};

FranceSpecificFooter.defaultProps = {
  sourcePOS: {},
  tranId: ''
};

FranceSpecificFooter.propTypes = {
  sourcePOS: PropTypes.shape(),
  tranId: PropTypes.string,
};

export default FranceSpecificFooter;
